/* eslint-disable no-template-curly-in-string, camelcase */
import React, { useRef } from 'react'
// @ts-ignore the fact it doesn't see core as module
import Filter from '../filter'
import type { FilterProps } from '../filter'
import SearchFilter from '../searchFilter'
import {
  FilterSchema,
  AuctionBlueprintFiltersActions,
  AuctionBlueprintFiltersData,
  // @ts-ignore not seeing type declaration
} from '@adc/blueprint'
import classnames from 'classnames/bind'
import type { StandardToolbarProps } from '../../../types'
import styles from './styles.scss'

const cx = classnames.bind(styles)

type AppModel = Record<string, unknown>

export type FilterToolbarProps = StandardToolbarProps & {
  filterData?: AuctionBlueprintFiltersData<
    AppModel,
    FilterSchema.FilterGroupViewModelCollection
  >
  filterActions?: AuctionBlueprintFiltersActions<
    AppModel,
    FilterSchema.FilterGroupViewModelCollection
  >
  searchText?: string
  setSearchText?: (value: string) => void
  searchPlaceholder?: string
  className?: string
  size?: FilterProps['size']
}

const FilterToolbar: React.FunctionComponent<FilterToolbarProps> = ({
  filterData,
  filterActions,
  searchText,
  setSearchText,
  searchPlaceholder = 'Search for text...',
  renderDataTableActions,
  className,
  size = 'medium',
}: FilterToolbarProps) => {
  const inputRef = useRef<HTMLInputElement>(null)

  const handleInputChange = (
    _e: React.ChangeEvent<HTMLInputElement>,
    data: Record<string, unknown>
  ) => {
    setSearchText && setSearchText(data.value as string)
  }

  return (
    <div className={cx('filter-toolbar', className)}>
      {setSearchText && (
        <SearchFilter
          inputRef={inputRef}
          placeholder={searchPlaceholder}
          size={size}
          value={searchText}
          onChange={handleInputChange}
          onResetIconClick={() => setSearchText('')}
        />
      )}
      {filterData?.filterDefinitions &&
        filterData.filterDefinitions.map(def => (
          <Filter
            size={size}
            key={def.name}
            data={filterData.filterViewModels[def.name]}
            onChange={(key: string, value: FilterSchema.ValueType) =>
              filterActions && filterActions.update(def.name, key, value)
            }
            onReset={() => filterActions && filterActions.reset(def.name)}
            definition={def}
            elmId={`${def.name}_filter`}
          />
        ))}
      <div
        style={{ marginLeft: 'auto', display: 'inline-flex' }}
        className={cx('filter-toolbar-actions')}
      >
        {renderDataTableActions && renderDataTableActions()}
      </div>
    </div>
  )
}

export default FilterToolbar
